<!--工作室课程-->
<template>
    <div class="studio_nav_content">
        <!--列表模式-->
        <div class="page-mode" v-show="showMode==='page'">
            <!-- 搜索条件 -->
            <div class="form-box">
                <el-form ref="queryForm"
                         :model="queryParams"
                         :inline="true"
                         >
                    <el-row class="mt10" >
                        <el-col :span="6" class="mb0">
                            <el-form-item label="学段">
                                <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择学段">
                                    <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="mb0">
                            <el-form-item label="年级">
                                <el-select clearable @change="changeGrade" v-model="queryParams.gradeKey" placeholder="请选择年级">
                                    <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="mb0">
                            <el-form-item label="学科">
                                <el-select clearable @change="pageEvaLesson(null)" v-model="queryParams.subjectKey" placeholder="请选择学科">
                                    <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="mb0">
                            <el-form-item label="状态">
                                <el-select clearable @change="pageEvaLesson(null)" v-model="queryParams.status" placeholder="请选择状态">
                                    <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="mt10">
                        <el-col :span="6">
                            <el-button style="background-color: #3b62f8;color: #fff;" @click="addEvaLesson">新增听评课</el-button>
                        </el-col>
                        <el-col :span="6" class="mb0">
                            <el-form-item label="性质" >
                                <el-select clearable @change="pageEvaLesson(null)" v-model="queryParams.lessonNature" placeholder="请选择备课性质">
                                    <el-option v-for="item in natureList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="是否参与">
                                <el-select clearable @change="pageEvaLesson(null)" v-model="queryParams.userIsJoin" placeholder="请选择">
                                    <el-option v-for="item in joinStatusList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item >
                                <el-input v-model="queryParams.title" placeholder="请输入名称" class="input-with-select">
                                    <template #append>
                                        <el-button type="primary" @click="pageEvaLesson(null)" style="background-color: #3b62f8;color: #fff" icon="el-icon-search" />
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="right-container">
                <div class="page-info-container">
                    <div class="info-list-container">
                        <div class="course-list-box">
                            <div class="course-item" v-for="item in dataList" :key="item">
                                <el-card :body-style="{ padding: '0px' }" class="course-one" @click="viewLesson(item)">
                                    <div class="course-name">{{item.title}}</div>
                                    <div class="course-info">
                                        <div class="course-cover">
                                            <img class="img-100"  :src="item.coverUrl" alt/>
                                        </div>
                                        <div class="course-title">
                                            <div class="course-subject">
                                                <div class="sub-info">{{item.periodName}}-{{item.gradeName}}-{{item.subjectName}}</div>
                                                <div class="status-info" v-if="item.status===1">初始</div>
                                                <div class="status-info" v-if="item.status===2">进行中</div>
                                                <div class="status-info-fb" v-if="item.status===3">已结束</div>
                                            </div>
                                            <div class="course-commend">授课教师:{{item.lectureTeacherName}}</div>
                                            <div class="course-commend">评课教师:{{item.rateTeacherNames}}</div>
                                            <div class="course-commend">听课类型:{{item.type===0?'推门':'线上'}}</div>
                                            <div class="course-commend">评课截止:{{ timestampToTime(item.rateEndTime)}}</div>
                                        </div>
                                    </div>
                                    <div class="course-time">听课时段:{{ timestampToTime(item.beginTime)}}至{{ timestampToTime(item.endTime)}}</div>
                                </el-card>
                            </div>
                        </div>
                        <data-empty v-if="dataList&&dataList.length===0" title="暂无数据"/>
                    </div>
                    <div class="page-container" v-if="dataList&&dataList.length>0">
                        <pageTag :background="true"
                                 :pageSizes="[6, 9, 12]"
                                 v-show="total > 0"
                                 :total="total"
                                 v-model:page.sync="queryParams.pageNum"
                                 v-model:limit.sync="queryParams.pageSize"
                                 @pagination="pageEvaLesson" />
                    </div>
                </div>
            </div>
        </div>
        <!--详情模式-->
        <div class="detail-mode" v-if="showMode==='detail'">
            <eva-lesson-info :lesson-id="this.lessonId"/>
        </div>
        <!-- 新增模式 -->
        <div class="detail-mode" v-if="showMode==='add'">
            <add-eva-lesson @change-show="changeShow"/>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import {timestampDate, timestampToTime} from "@/utils/date";
import {queryDict} from "@/api/admin/public";
import { evaluationPageLessons} from "@/api/admin/evaluation"
import evaLessonInfo from "@/components/eduResearch/evaLessonInfo.vue";
import addEvaLesson from "@/components/eduResearch/addEvaLesson.vue";

export default {
    name:'appEduEvaLesson',
    components:{addEvaLesson, evaLessonInfo, pageTag, dataEmpty},
    props:{
        title:{
            type: String,
            default:null
        },
        courseType:{
            type: String,
            default:null
        },
        courseMode:{
            type: String,
            default:'page'
        },
        parentId:{
            type: String,
            default:''
        }
    },
    watch:{
        courseMode(newValue,oldValue){
            this.showMode = newValue;
            this.pageEvaLesson()
        },
        parentId(newValue,oldValue){
            this.courseId = newValue;
        },
    },
    mounted() {
        this.getQueryDict();
        this.pageEvaLesson();
    },
    data() {
        return {
            showMode:'page',
            timestampDate,
            timestampToTime,
            itemName:'高水平示范课',
            itemKey:'',
            queryParams: {
                status: '',
                title: '',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                pageNum: 1,
                pageSize: 6,
                // type:0,
                lessonNature:'',
                userIsJoin:'',
            },
            total: 0,
            pageCount:0,
            dataList: [],
            lessonId:'',
            periodList: [],
            gradeList: [],
            subjectList: [],
            statusList: [
                { name: '初始', value: 1 },
                { name: '进行中', value: 2 },
                { name: '已结束', value: 3 },
            ],
            joinStatusList: [
                { name: '全部', value: 1 },
                { name: '我参与的', value: 2 },
            ],
            natureList: [],
        }
    },
    methods: {
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'activity_nature' }).then(res => {
                this.natureList = res.data.data;
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.queryParams.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.pageEvaLesson()
        },
        changeGrade() {
            this.queryParams.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.queryParams.periodKey === e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.queryParams.gradeKey === j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
            this.pageEvaLesson()
        },
        pageEvaLesson(){
            evaluationPageLessons(this.queryParams).then(res => {
                this.dataList = res.data.data.list;
                this.total = res.data.data.total;
                this.pageCount = res.data.data.totalPage;
                res.data.data.list.forEach(e => {
                    //评课老师
                    const rateTextList = [];
                    e.rateTeacherList.forEach(j => {
                        rateTextList.push(j.trueName)
                    })
                    e.rateTeacherNames = rateTextList.join('、')
                })
            });
        },
        viewLesson(item){
            this.showMode = "detail"
            this.lessonId = item.lessonId;
            this.$emit('change-mode',this.showMode);
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 5);
        },
        changeShow(item){
            this.pageEvaLesson()
            this.showMode = item;
        },
        addEvaLesson(){
            this.showMode = "add";
            this.$emit('change-mode',this.showMode);
        },
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
/*=====*/
.page-mode{
    width: 100%;
    height: calc(100vh - 20px);
    background-color: #fff;
}
.form-box{
    width: 98%;
    height: auto;
    margin: auto;
    border-bottom: 2px solid #3b62f8;
    background-color: #fff;
    padding-top: 5px;
}
.right-container{
    width: 100%;
    height: auto;
}
.page-info-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    background-color: #fff;
}
.info-top-title{
    width: 99%;
    height: 34px;
    margin: auto;
    line-height: 30px;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
}
.title{
    padding-right: 10px;
    border-bottom: 2px solid #3b62f8;
}
/*=====*/
.info-list-container{
    width: 100%;
    height: calc(100vh - 190px)!important;
    margin: auto;
    overflow-x: hidden;
}
/*课程*/
.course-list-box{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding-right: 10px;
    padding-top: 10px;
    align-items: center;
    box-sizing: border-box;
    background-color: #fff;
}
.course-item{
    width: 33.3%!important;
    height: auto;
    padding-left: 10px;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.course-one{
    width: 100%;
    height: 100%;
    padding: 10px;
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
}
.course-info{
    display: flex;
    width: 100%;
    height: 100px;
    padding-bottom: 8px;
    //padding-top: 5px;
}
.course-cover{
    width: 40%;
    height: 100%;
    box-shadow: var(--el-box-shadow-light);
    img{
        width: 100%;
        height: 100%;
    }
}
.course-title{
    width: 60%;
    height: 100%;
}
.course-name{
    width: 100%;
    font-size: 15px;
    color: #333;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 45px;
}
.course-time{
    width: 100%;
    font-size: 14px;
    color: #333;
    height: 20px;
    line-height: 20px;
    text-align: center;
}
.course-subject{
    padding-left: 10px;
    box-sizing: border-box;
    font-size: 14px;
    color: #333333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 20px;
    display: flex;
}
.sub-info{
    width: calc(100% - 50px);
    color: #333333;
    height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.status-info{
    width: 50px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #a2ef4d;
    font-size: 12px;
    text-align: center;
    color: #e87b17;
}
.status-info-fb{
    width: 50px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #e87b17;
    font-size: 12px;
    text-align: center;
    color: #a2ef4d;
}
.course-commend{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    color: #333333;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.course-team-user{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    color: #333333;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    padding-top: 15px;
    box-sizing: border-box;
}
.detail-mode{
    width: 100%;
    height: auto;
}
</style>